<template>
  <v-col class="language_panel no-gutters">
    <v-row no-gutters justify="space-between" align-content="center" class="d-flex flex-nowrap" v-for="(lang, index) in filterLanguages" :key="lang.currency">
      <div no-gutters class="align-self-center flex-shrink-1">
        <v-avatar class="language-button" :size="$vuetify.breakpoint.xsOnly ? '35' : '48'">
          <img width="60" height="60" :src="`/static/image/country/${lang.img}.svg`" alt="nagad88 cricket exchange" />
        </v-avatar>
      </div>
      <div class="align-self-center flex-shrink-1 mx-2">
        <label class="">{{ lang.currencyCd }} {{ lang.currency }}</label>
      </div>
      <v-row no-gutters justify="center" class="align-self-center flex-grow-1 d-flex flex-nowrap">
        <!-- <v-col v-model="selectedLanguage" class="pl-2" v-for="l in lang.language" :key="l.cd">
                <v-btn :value="lang.currency + l.cd" class="font-weight-bold text-capitalize flex-grow-1" outlined @click="changeLanguage(l.cd, lang.currency)">{{l.title}}</v-btn>
            </v-col> -->

        <v-btn-toggle v-model="selectedLanguage" :group="true" :borderless="true" dense class="pl-2 flex-grow-1" v-for="l in lang.language" :key="l.cd">
<!--          <a :href="`${l.cd}/${getLocalizedPath(l.cd, cleanPath)}`">-->
          <!-- href stays for crawlers; the tap is handled by changeLanguage, so the link must not navigate too -->
          <a class="localized" :href="localizedLink(l.cd)" @click.prevent>
            <v-btn :value="lang.currency + l.cd" class="font-weight-bold text-capitalize full-width" outlined @click="changeLanguage(l.cd, lang.currency)">
<!--              {{ l.title }}-->

                {{ l.title }}

            </v-btn>
<!--          </a>-->
          </a>
        </v-btn-toggle>
      </v-row>
    </v-row>
<!--    <v-row no-gutters class="mt-2">-->
<!--      <v-divider v-if="index < languageList.length - 1" class="language-divider"></v-divider>-->
<!--    </v-row>-->
  </v-col>
</template>

<script>
import stingFormat from 'string-format'
import { formValidator, uiHelper, errorCodeHelper } from '@/util'
import { SHARED } from '@/constants/constants'
import { MEMBER_LOGIN } from '@/store/member.module'
export default {
  name: 'appLanguage',
  props: {
    closeAction: {
      type: Function,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    cleanPath: null, // Dynamic path value
    languageList: [
      {
        currency: 'BDT',
        currencyCd: '৳',
        img: 'BDT',
        language: [
          {
            title: 'English',
            cd: 'en'
          },
          {
            title: 'Bengali',
            cd: 'bd'
          }
        ]
      }
      // {
      //     currency: 'INR',
      //     currencyCd: '₹',
      //     img: "INR",
      //     language: [
      //         {
      //             title: 'English',
      //             cd: 'en'
      //         },
      //         {
      //             title: 'Tamil',
      //             cd: 'ta'
      //         }
      //     ]
      // }
    ],
    selectedLanguage: '',
    currentLanguage: uiHelper.getLanguage()
  }),
  computed: {
    modifiedLanguageCodes() {
      // Map language codes to their modifications
      const modifications = {
        'bd': 'bn', // Add other mappings if needed
      };
      return modifications;
    },
    localizedLink() {
      return (languageCode) => {
        const modifiedCode = this.modifiedLanguageCodes[languageCode] || languageCode;
        // Absolute, no trailing slash: "/" used to give "en-BD/", which the strict home route sends to 404
        return `/${modifiedCode}-BD${this.getLocalizedPath()}`;
      };
    },
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    currentCurrency() {
      return uiHelper.getCurrency()
    },
    filterLanguages() {
      if (this.isLoggedIn) {
        let list = this.languageList.filter(l => l.currency == this.currentCurrency)
        if (list && list.length > 0) return list
        else return this.languageList
      } else {
        return this.languageList
      }
    }
  },
  created() {
    this.selectedLanguage = this.currentCurrency + this.currentLanguage
  },
  methods: {
    getCountryCode(code) {
      let REG = /^[a-z]{2,}(?:-[A-Z][a-z]*)*-([A-Z]{2})$/;
      var match = code.match(REG);
      if (!match) return "";
      // console.log('isValidCountryCode:', match);
      return match[1];

    },
//     changeLanguage(languageCd, currCd) {
//       this.$store.dispatch(`${SHARED.LOADING}`)
//       uiHelper.removeCookie('language')
//       uiHelper.setCookie('language', languageCd)
//       uiHelper.removeCookie('changeLanguage')
//       uiHelper.setCookie('changeLanguage', true)
//       uiHelper.setCurrency(currCd)
//         const langRegion = (languageCd == 'bd' ? 'bn' : languageCd) + '-' + currCd.substring(0, 2);
//         uiHelper.removeCookie('regionLocale');
//         uiHelper.setCookie('regionLocale', langRegion);
//
//       // window.location.href = '/'
//       // let extractPath = window.location.pathname.split('/');
//       let extractPath = window.location.pathname.split('/');
//       // console.log('extractPath:', extractPath);
// // Rest of your code
//         const results = extractPath.filter(element => {
//           return element !== '';
//         });
//       console.log('Results:', results);
//         // if (results.length > 0) {
//         //   let region = results[0];
//         //   console.log('region:', region);
//         //   // test is valid locale
//         //   let isValidCountryCode = this.getCountryCode(region);
//         //   console.log('isValidCountryCode:', this.getCountryCode(region));
//         //   const newArr = [uiHelper.getRegionLocale(), ...results.slice(1)];
//         //   const joinUrl = newArr.join("/");
//         //   console.log('location replace to 1:',  joinUrl)
//         //   console.log('location replace to 2:',window.location.origin + "/" + joinUrl +"/" + region)
//         //   // debugger +"/" + region
//         //   debugger
//         //   window.location.replace(window.location.origin + '/' + joinUrl);
//       if (results.length > 0) {
//         let region = results[0];
//         //test is valid locale
//         let isValidCountryCode = this.getCountryCode(region);
//         if (isValidCountryCode) {
//           const newArr = [uiHelper.getRegionLocale(), ...results.slice(1)];
//           const joinUrl = newArr.join("/");
//           window.location.replace(window.location.origin + "/" + joinUrl);
//         }
//       } else {
//         window.location.reload();x
//       }
//
//     },
    getLocalizedPath() {
      const path = window.location.pathname;
      const cleanPath = path.replace(/\/(en-BD|bn-BD)/i, '').replace(/\/+$/, '');
      return cleanPath;
    },
    changeLanguage(languageCd, currCd) {
      this.$store.dispatch(`${SHARED.LOADING}`);
      const langRegion = (languageCd == 'bd' ? 'bn' : languageCd) + '-' + currCd.substring(0, 2);
      uiHelper.removeCookie('regionLocale');
      uiHelper.removeCookie('language');
      uiHelper.removeCookie('changeLanguage');
      uiHelper.setCookie('regionLocale', langRegion);
      uiHelper.setCookie('language', languageCd);
      uiHelper.setCookie('changeLanguage', true);
      uiHelper.setCurrency(currCd);
      let extractPath = window.location.pathname.split('/');
      const results = extractPath.filter(element => {
        return element !== '';
      });
      // Drop an existing locale segment, then prefix the new one. Building the URL directly avoids
      // router.push + reload, which on a bare "/" produced "/en-BD/" and the strict home route sent it to 404.
      const rest = results.length > 0 && this.getCountryCode(results[0]) ? results.slice(1) : results;
      const joinUrl = [uiHelper.getRegionLocale(), ...rest].join('/');
      window.location.replace(window.location.origin + '/' + joinUrl + window.location.search);
    }
  }
}
</script>

<style lang="scss">
.language_panel {
  color: #000000;
  background-color: #ffffff;
  padding: 12px 16px !important;

  .language-divider {
    border-color: var(--v-border-base);
  }

  .v-btn-toggle--group {
    .v-btn {
      color: #000000;
      border: 1px solid var(--v-description-base);

      &.v-btn--active {
        background: transparent linear-gradient(180deg, #ffab2d 0%, #ff7700 100%) 0% 0% no-repeat padding-box;
        color: #fff;
        //border: 1px solid var(--v-primary-base);
      }
    }

    .v-btn:hover {
      color: var(--v-primary-base);
      border: 1px solid var(--v-primary-base);
    }
  }

  .v-btn::before {
    background-color: unset;
  }
}

@media (max-width: 959px) {
  // .language_panel {
  //     color: unset;
  //     background-color: #3e3e3e;
  //     padding: unset;

  //     .v-btn-toggle--group {
  //         .v-btn {
  //             color: unset;
  //             border: 1px solid #ffffff;

  //             &.v-btn--active {
  //                 color: var(--v-secondary-base);
  //                 border-color: var(--v-secondary-base);
  //                 border: 1px solid var(--v-secondary-base);
  //             }
  //         }
  //     }
  // }
}

@media (max-width: 425px) {
  .language_panel {
    .v-btn {
      font-size: 12px !important;
      height: 35px !important;
    }
  }
}
</style>
